import { CiscoIconUrl } from "@p0security/shared/integrations/constants";
import { CsaComponents } from "@p0security/shared/integrations/resources/csa/components";
import { csaInstaller } from "components/Integrations/Csa/install/install";
import { Install, InstallProps } from "components/Integrations/Install/Install";
import { useCallback } from "react";

export const Csa = (
  props: Pick<InstallProps<typeof CsaComponents>, "cardOverride" | "onInstall">
) => {
  const itemKind = useCallback(() => "organization", []);

  return (
    <Install<typeof CsaComponents>
      components={CsaComponents}
      installer={csaInstaller}
      integration="cisco-secure-access"
      itemKind={itemKind}
      logo={CiscoIconUrl}
      title="Cisco Secure Access"
      {...props}
    />
  );
};
